import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var myAccountRoute = [{
  path: "my-account",
  name: "my-account",
  component: function component() {
    return import("./my-account.vue");
  }
}];